import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "@tanstack/react-router";
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { ADMIN_PORTAL_NAV_ITEMS, AdminAppSidebar } from "@/components/Sidebar/AdminAppSidebar";
import { useTokenExpirationCheck } from "@/hooks/useTokenExpirationCheck";

export function AdminDashboardLayout() {
  const { t } = useTranslation();
  const location = useLocation();

  useTokenExpirationCheck();

  const breadcrumbPageName =
    ADMIN_PORTAL_NAV_ITEMS.find((item) => location?.pathname?.includes(item.url))?.title ??
    location?.pathname?.split("/")?.pop();

  return (
    <SidebarProvider>
      <AdminAppSidebar className="border-r" />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator orientation="vertical" className="mr-2 h-4" />
            <Breadcrumb>
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbPage>{t(breadcrumbPageName ?? "")}</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>
          </div>
        </header>
        <main className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
